import { createSelector } from 'reselect';

const getQuoteAppt = state => state.quoteAppt;

export const getIsQuoteAppt = createSelector(
  getQuoteAppt,
  ({ isQuoteAppt }) => isQuoteAppt
);

export const getReadOnlyServices = createSelector(
  getQuoteAppt,
  ({ readOnlyServices }) => readOnlyServices
);

export const getReadOnlyPackage = createSelector(
  getQuoteAppt,
  ({ readOnlyPackage }) => readOnlyPackage
);

export const getShowQuoteApptError = createSelector(
  getQuoteAppt,
  ({ showError }) => showError
);

export const getQuoteConfirmationId = createSelector(
  getQuoteAppt,
  ({ quoteConfirmationId }) => quoteConfirmationId
);

export const getFormattedQuoteServices = createSelector(
  getReadOnlyServices,
  quoteServices => {
    const formattedServices =
      quoteServices &&
      quoteServices.filter(service => service.selected).map(service => {
        const { id, serviceKind, quoteServiceId } = service;
        return {
          id,
          serviceKind,
          quoteServiceId
        };
      });
    return quoteServices ? formattedServices : [];
  }
);

export const getQuotePackagesServicesSelected = createSelector(
  getReadOnlyPackage,
  readOnlyPackage => {
    const quotePackageServices = readOnlyPackage && readOnlyPackage.services;
    return (
      quotePackageServices &&
      quotePackageServices.filter(
        quoteService => quoteService.selectByDefault === true
      )
    );
  }
);

export const getFormattedQuotePackage = createSelector(
  getReadOnlyPackage,
  getQuotePackagesServicesSelected,
  getQuoteConfirmationId,
  (quotePackage, selectedServices, quoteConfirmationId) => {
    if (!quotePackage) {
      return {};
    }
    const formattedServices =
      selectedServices &&
      selectedServices.map(service => ({
        id: service.id
      }));
    const formattedPackage = {
      menuType: {
        services: formattedServices,
        quoteConfirmationId
      },
      quoteServiceId: quotePackage.quoteServiceId
    };
    return quotePackage.selected ? formattedPackage : {};
  }
);



// WEBPACK FOOTER //
// ./src/store/reducers/quoteAppt/selectors.js